import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_DEVICES: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_DEVICES_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_DEVICES_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.DEVICE_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.DEVICE_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.DEVICE_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.DEVICE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.DEVICE_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
